import { TSelectionPages } from "../../../../Types";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Header from "./Header";
import InputFields from "./input-fields";
import SideAiActions from "./SideAiActions";

const AiMessages = withLiteObserverAndTheme<{ pageType: TSelectionPages }>(
  (props) => {
    const { pageType } = props;

    return (
      <ET3Div
        width={1510}
        height={0}
        alignItems={"flex-end"}
        fDirection={"column"}
        style={{}}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <Header />
        <ET3Div
          width={1510}
          height={0}
          alignItems={"center"}
          fDirection={"row"}
          style={{}}
          color={""}
          justifyContent={"flex-start"}
          withShadow={false}
          isExtendable={true}
          isScrollable={false}
          onClick={() => {}}
        >
          <InputFields pageType={pageType} />
          <SideAiActions pageType={pageType} />
        </ET3Div>
      </ET3Div>
    );
  }
);

export default AiMessages;
